import type { Locale } from './en';

// Gujarati (ગુજરાતી) locale. Mirrors the English key structure exactly. Any key
// that is ever missing here automatically falls back to English at runtime.
export const gu: Locale = {
  nav: {
    home: 'હોમ',
    about: 'અમારા વિશે',
    features: 'વિશેષતાઓ',
    categories: 'શ્રેણીઓ',
    howItWorks: 'આ કેવી રીતે કામ કરે છે',
    solutions: 'ઉકેલો',
    contact: 'સંપર્ક',
    complaints: 'ફરિયાદો',
    fileComplaint: 'ફરિયાદ નોંધાવો',
    trackComplaint: 'ફરિયાદ ટ્રૅક કરો',
    signIn: 'સાઇન ઇન',
    staffDashboard: 'સ્ટાફ ડૅશબોર્ડ',
    language: 'ભાષા',
    changeLanguage: 'ભાષા બદલો',
    selectLanguage: 'ભાષા પસંદ કરો',
    skipToContent: 'મુખ્ય સામગ્રી પર જાઓ',
  },

  hero: {
    badge: 'એઆઈ-સંચાલિત નાગરિક નિરીક્ષણ',
    titleLine1: 'એઆઈ-સંચાલિત નાગરિક',
    titleHighlight: 'સ્વચ્છતા નિરીક્ષણ',
    titleLine3: 'પ્લેટફોર્મ',
    subtitle:
      'જિયો-ટૅગ કરેલા નાગરિક પુરાવા કૅપ્ચર કરો, એઆઈ વડે સ્વચ્છતાનું વિશ્લેષણ કરો, નગરપાલિકાને રિપોર્ટ મોકલો, સફાઈ કાર્યો સોંપો, એસએલએ ટ્રૅક કરો, અને પહેલાં/પછીના પુરાવા સાથે ઉકેલ ચકાસો.',
    ctaFile: 'ફરિયાદ નોંધાવો',
    ctaDemo: 'નગરપાલિકા ડેમો બુક કરો',
    ctaTrack: 'પહેલેથી નોંધાવી છે? તમારી ફરિયાદ ટ્રૅક કરો',
    trust1: 'જીપીએસ અને ટાઇમસ્ટૅમ્પ પુરાવો',
    trust2: 'એઆઈ સ્વચ્છતા સ્કોરિંગ',
    trust3: 'એસએલએ અને ઓડિટ રિપોર્ટ',
    systemStatus: 'સિસ્ટમ સ્થિતિ',
    allActive: 'બધી સિસ્ટમ સક્રિય',
    degraded: 'અવરોધિત',
    liveTracking: 'લાઇવ ટ્રૅકિંગ',
    fieldCapture: 'ફિલ્ડ કૅપ્ચર',
    aiScore: 'એઆઈ સ્કોર',
    liveOverview: 'લાઇવ ઝાંખી',
    live: 'લાઇવ',
    unavailable: 'અનુપલબ્ધ',
    statsUnavailable: 'લાઇવ આંકડા હાલમાં અસ્થાયી રૂપે અનુપલબ્ધ છે.',
    reports: 'રિપોર્ટ',
    clean: 'સ્વચ્છતા',
    wards: 'વોર્ડ',
    inProgress: 'પ્રગતિમાં',
    hotspotMap: 'હૉટસ્પૉટ નકશો',
    slaAlert: 'એસએલએ ચેતવણી',
    poweredBy: 'OpenAI GPT-4o Vision દ્વારા સંચાલિત',
    stepSubmitted: 'નોંધાયેલ',
    stepReview: 'સમીક્ષા',
    stepAssigned: 'સોંપાયેલ',
    stepCleaning: 'સફાઈ',
    stepVerified: 'ચકાસાયેલ',
  },

  trustStrip: {
    municipalities: 'નગરપાલિકાઓ માટે',
    sanitation: 'સફાઈ ટીમો માટે',
    citizens: 'નાગરિકો માટે',
    inspectors: 'નિરીક્ષકો માટે',
  },

  problem: {
    badge: 'પડકાર',
    title: 'મેન્યુઅલ નાગરિક નિરીક્ષણ ખામીયુક્ત છે',
    subtitle: 'પરંપરાગત પદ્ધતિઓ અંધ સ્થળો, વિલંબ અને અચકાસાયેલ દાવા ઊભા કરે છે.',
    items: [
      'કાગળ-આધારિત નિરીક્ષણ ચકાસવું મુશ્કેલ છે',
      'ફોટામાં જીપીએસ / ટાઇમસ્ટૅમ્પ પુરાવો હોતો નથી',
      'સમસ્યાનો ઉકેલ મોડો આવે છે',
      'કોઈ એસએલએ ટ્રૅકિંગ નથી',
      'પુરાવા-આધારિત જવાબદારી નથી',
      'નાગરિકો પ્રગતિ ટ્રૅક કરી શકતા નથી',
    ],
    manualTitle: 'મેન્યુઅલ કાગળી નિરીક્ષણ',
    manualForm: 'હાથે લખેલ ફોર્મ',
    manualFormSub: 'કોઈ સ્થાન નહીં · કોઈ સમય નહીં · કોઈ પુરાવો નહીં',
    manualBads: ['અચકાસાયેલ દાવા', 'રસ્તામાં ખોવાઈ જાય', 'કોઈ ફોલો-અપ નહીં'],
    aiTitle: 'એઆઈ મોબાઇલ નિરીક્ષણ',
    aiScoreLabel: 'એઆઈ સ્વચ્છતા સ્કોર',
    aiGoods: ['જીપીએસ + ટાઇમસ્ટૅમ્પ', 'એઆઈ સ્કોર અને ગંભીરતા', 'ઉકેલ સુધી ટ્રૅક'],
  },

  solution: {
    badge: 'અમારો ઉકેલ',
    title: 'ટેક્નોલોજી-સંચાલિત નાગરિક સલામતી',
    subtitle: 'એઆઈ-સંચાલિત પુરાવા સંગ્રહ અને કેન્દ્રિત દેખરેખ સાથે સ્વચ્છતા નિરીક્ષણને આધુનિક બનાવો.',
    cards: [
      { title: 'ફોટો પુરાવો', sub: 'જીપીએસ અને ટાઇમસ્ટૅમ્પ સહિત' },
      { title: 'એઆઈ વિશ્લેષણ', sub: 'સ્વયંસંચાલિત સ્કોરિંગ' },
      { title: 'લાઇવ ટ્રૅકિંગ', sub: 'રીઅલ-ટાઇમ અપડેટ' },
      { title: 'એનાલિટિક્સ', sub: 'વલણ અંતર્દૃષ્ટિ' },
    ],
    checklist: [
      'એઆઈ તાત્કાલિક સ્વચ્છતા સ્કોરિંગ માટે ફોટાનું વિશ્લેષણ કરે છે',
      'દરેક રિપોર્ટ સાથે જીપીએસ-ચકાસાયેલ પુરાવો જોડાયેલ',
      'નગરપાલિકા અધિકારીઓ માટે રીઅલ-ટાઇમ ડૅશબોર્ડ',
      'નાગરિક ફરિયાદો દ્વારા જાહેર પારદર્શિતા',
    ],
  },

  lifecycle: {
    badge: 'સંપૂર્ણ કાર્યપ્રવાહ',
    title: 'ફરિયાદથી ઉકેલ સુધી',
    subtitle: 'એક જ, સંપૂર્ણપણે ટ્રૅક કરી શકાય તેવું જીવનચક્ર — પ્રથમ ફોટોથી લઈને ચકાસાયેલ, ઓડિટ-તૈયાર બંધ સુધી.',
    cta: 'સંપૂર્ણ કાર્યપ્રવાહ જુઓ',
    steps: [
      { title: 'ફોટો કૅપ્ચર કરો', desc: 'અધિકારી કે નાગરિક સ્થળ પર નાગરિક સમસ્યાનો ફોટો લે છે.' },
      { title: 'જીપીએસ અને ટાઇમસ્ટૅમ્પ પુરાવો', desc: 'દરેક ફોટા પર સ્થાન અને સમય અંકિત થાય છે.' },
      { title: 'એઆઈ સ્વચ્છતા વિશ્લેષણ', desc: 'એઆઈ સ્વચ્છતા સ્કોર આપે છે, સમસ્યા અને ગંભીરતા ઓળખે છે.' },
      { title: 'નગરપાલિકાને મોકલો', desc: 'રિપોર્ટ યોગ્ય વોર્ડ અને વિભાગ સુધી પહોંચે છે.' },
      { title: 'એડમિન સમીક્ષા', desc: 'અધિકારીઓ એઆઈ પરિણામ ચકાસી કાર્યવાહી મંજૂર કરે છે.' },
      { title: 'સફાઈ કાર્ય સોંપો', desc: 'કાર્ય સમયમર્યાદા સાથે સફાઈ ટીમને સોંપાય છે.' },
      { title: 'કર્મચારી પછીનો ફોટો અપલોડ કરે છે', desc: 'કાર્ય પૂર્ણ થતાં ટીમ પુરાવો અપલોડ કરે છે.' },
      { title: 'પહેલાં / પછી ચકાસણી', desc: 'એક જ સ્થાનના પહેલાં અને પછીના ફોટાની સરખામણી થાય છે.' },
      { title: 'એસએલએ બંધ', desc: 'સમસ્યા તેના એસએલએ અંદર બંધ થાય છે — અથવા એસ્કેલેટ થાય છે.' },
      { title: 'પીડીએફ / ઓડિટ રિપોર્ટ', desc: 'છેડછાડ-રહિત ઓડિટ રિપોર્ટ તૈયાર થાય છે.' },
    ],
  },

  ai: {
    badge: 'એઆઈ-સંચાલિત',
    title: 'સ્વચ્છ ભારત એઆઈ કેવી રીતે કામ કરે છે',
    subtitle:
      'દરેક ફોટો એક એઆઈ પાઇપલાઇનમાંથી પસાર થાય છે જે સ્વચ્છતા સ્કોર આપે છે, સમસ્યા ઓળખે છે અને કાર્યવાહીની ભલામણ કરે છે — જેથી નિર્ણયો સુસંગત, ઝડપી અને પુરાવા-આધારિત રહે.',
    capabilities: [
      { label: 'છબી ગુણવત્તા તપાસે છે', desc: 'અસ્પષ્ટ, ઘાટા કે અનુપયોગી ફોટા નકારે છે.' },
      { label: 'નાગરિક સમસ્યા શોધે છે', desc: 'કચરો, ગટર, કાટમાળ વગેરે ઓળખે છે.' },
      { label: 'સ્વચ્છતા સ્કોર આપે છે', desc: 'A+ થી F ગ્રેડ સાથે 0–100 સ્કોર.' },
      { label: 'ગંભીરતા અને પ્રાધાન્ય નક્કી કરે છે', desc: 'ઝડપી કાર્યવાહી માટે ઉચ્ચ-ગંભીરતા સમસ્યાઓ ચિહ્નિત કરે છે.' },
      { label: 'કાર્યવાહીની ભલામણ કરે છે', desc: 'સંભવિત વિભાગ અને આગળનું પગલું સૂચવે છે.' },
      { label: 'ડુપ્લિકેટ / અમાન્ય ફોટા ચિહ્નિત કરે છે', desc: 'પુનરાવર્તન અને છેડછાડ કરેલી છબીઓ પકડે છે.' },
    ],
    trustBold: 'એઆઈ નિર્ણય લેવામાં મદદ કરે છે.',
    trustText: 'અંતિમ નગરપાલિકા કાર્યવાહીની સમીક્ષા અને ઓવરરાઇડ અધિકૃત અધિકારીઓ કરી શકે છે — નિયંત્રણ માણસો પાસે રહે છે.',
    resultTitle: 'એઆઈ વિશ્લેષણ પરિણામ',
    resultSub: 'લાઇવ ઉદાહરણ — કચરાનો ઉભરાવો',
    scoreLabel: 'સ્વચ્છતા સ્કોર',
    grade: 'ગ્રેડ C',
    rows: [
      { k: 'શોધાયેલ સમસ્યા', v: 'કચરાનો ઉભરાવો' },
      { k: 'ગંભીરતા', v: 'ઉચ્ચ' },
      { k: 'ભલામણ', v: 'સફાઈ ટીમને સોંપો' },
      { k: 'ડુપ્લિકેટ તપાસ', v: 'પાસ' },
    ],
    analyzedBy: 'OpenAI GPT-4o Vision દ્વારા વિશ્લેષિત · અધિકારીઓ દ્વારા સમીક્ષાયોગ્ય',
  },

  features: {
    badge: 'પ્લેટફોર્મ વિશેષતાઓ',
    title: 'અસરકારક દેખરેખ માટે બધું જ',
    subtitle: 'નગરપાલિકા અધિકારીઓ, નિરીક્ષકો અને નાગરિકો માટે વ્યાપક સાધનો',
    unavailable: 'વિશેષતાઓ હાલમાં અનુપલબ્ધ છે. કૃપા કરીને પછી પ્રયાસ કરો.',
    notConfigured: 'પ્લેટફોર્મ વિશેષતાઓ હજુ ગોઠવાયેલી નથી. કૃપા કરીને પછી તપાસો.',
    viewAll: 'બધી વિશેષતાઓ જુઓ',
  },

  workflow: {
    badge: 'કાર્યપ્રવાહ',
    title: 'સુવ્યવસ્થિત નિરીક્ષણ કાર્યપ્રવાહ',
    subtitle: 'ફિલ્ડ કૅપ્ચરથી ઉકેલ સુધી સંપૂર્ણપણે ટ્રૅક કરી શકાય તેવી પ્રક્રિયા',
    step: 'પગલું',
    fallback: [
      { title: 'કૅપ્ચર', description: 'ફિલ્ડ અધિકારી જિયો-ટૅગ કરેલ ફોટો લે છે.' },
      { title: 'વિશ્લેષણ', description: 'એઆઈ સ્વચ્છતા સ્કોર આપે છે અને સમસ્યા ઓળખે છે.' },
      { title: 'સમીક્ષા', description: 'અધિકારીઓ એઆઈ પરિણામ સમીક્ષા કરી મંજૂરી આપે છે.' },
      { title: 'સોંપણી', description: 'એસએલએ સાથે સફાઈ કાર્ય સોંપાય છે.' },
      { title: 'ચકાસણી', description: 'પહેલાં/પછીનો પુરાવો કાર્યની પુષ્ટિ કરે છે.' },
      { title: 'રિપોર્ટ', description: 'છેડછાડ-રહિત ઓડિટ રિપોર્ટ તૈયાર થાય છે.' },
    ],
  },

  beforeAfter: {
    badge: 'ચકાસણી',
    title: 'પુરાવા-આધારિત સફાઈ ચકાસણી',
    subtitle:
      'દરેક બંધ એક જ સ્થાનના મેળ ખાતા પહેલાં અને પછીના ફોટા દ્વારા સમર્થિત હોય છે — માત્ર એક ચેકબોક્સ નહીં.',
    before: 'પહેલાં',
    after: 'પછી',
    beforeIssue: 'કચરાનો ઉભરાવો',
    afterCleared: 'સાફ અને સ્વચ્છ',
    improvement: 'સુધારો સ્કોર',
    items: [
      { title: 'પહેલાંનો ફોટો', desc: 'સમસ્યા નોંધાવતી વખતે અધિકારી કે નાગરિક દ્વારા લેવાય છે.' },
      { title: 'પછીનો ફોટો', desc: 'કાર્ય પૂર્ણ થતાં સફાઈ કર્મચારી દ્વારા અપલોડ થાય છે.' },
      { title: 'સમાન-સ્થાન ચકાસણી', desc: 'જીપીએસ પુષ્ટિ કરે છે કે પછીનો ફોટો નોંધાયેલ સ્થળ સાથે મેળ ખાય છે.' },
      { title: 'સુધારો સ્કોર', desc: 'એઆઈ બંને ફોટાની સરખામણી કરી વાસ્તવિક સુધારો માપે છે.' },
      { title: 'એડમિન ચકાસણી', desc: 'સમસ્યા બંધ કરતાં પહેલાં અધિકારી કાર્યની પુષ્ટિ કરે છે.' },
      { title: 'સાફ ન થાય તો ફરી ખોલો', desc: 'નબળું કાર્ય આપોઆપ ફરી ખોલાય અને ફરી સોંપાય છે.' },
      { title: 'પીડીએફ પુરાવો', desc: 'રેકોર્ડ માટે પહેલાં/પછીની ઓડિટ પીડીએફ તૈયાર થાય છે.' },
    ],
  },

  commandCenter: {
    badge: 'નગરપાલિકા કમાન્ડ સેન્ટર',
    title: 'આખા શહેરને ચલાવવા માટે એક ડૅશબોર્ડ',
    subtitle: 'એક રીઅલ-ટાઇમ કમાન્ડ સેન્ટર જે હજારો રિપોર્ટને સ્પષ્ટ, પ્રાધાન્ય-આધારિત કાર્યવાહીમાં ફેરવે છે.',
    cta: 'ડૅશબોર્ડ ડેમો જુઓ',
    features: [
      { title: 'રીઅલ-ટાઇમ કમાન્ડ સેન્ટર', desc: 'દરેક વોર્ડ અને રિપોર્ટનું એક લાઇવ દૃશ્ય.' },
      { title: 'સમીક્ષા બાકી રિપોર્ટ', desc: 'આધિકારિક સમીક્ષાની રાહ જોતી આવતી રિપોર્ટ.' },
      { title: 'કાર્યવાહી જરૂરી રિપોર્ટ', desc: 'તાત્કાલિક નિર્ણયની જરૂરવાળી રિપોર્ટ.' },
      { title: 'એસએલએ મુદત વીતી ચેતવણી', desc: 'સમયમર્યાદા ચૂકતાં એસ્કેલેશન.' },
      { title: 'નિષ્ફળ એઆઈ → મેન્યુઅલ સમીક્ષા', desc: 'ઓછા-વિશ્વાસવાળા એઆઈ પરિણામ માણસોને મોકલાય છે.' },
      { title: 'વોર્ડ પ્રદર્શન', desc: 'વોર્ડોમાં સ્વચ્છતાની સરખામણી કરો.' },
      { title: 'શ્રેણી આરોગ્ય સ્કોર', desc: 'કઈ સમસ્યાઓ વધી રહી છે તે ટ્રૅક કરો.' },
      { title: 'પ્રાધાન્ય કાર્ય કતાર', desc: 'સૌથી તાકીદનું કાર્ય, પ્રથમ ક્રમે.' },
      { title: 'નકશો દૃશ્ય', desc: 'બધી લાઇવ સમસ્યાઓનું ભૂ-સ્થાનિક દૃશ્ય.' },
      { title: 'પીડીએફ / સીએસવી નિકાસ', desc: 'માંગ પર ઓડિટ-તૈયાર રિપોર્ટ નિકાસ કરો.' },
    ],
    mockTitle: 'કમાન્ડ સેન્ટર',
    pending: 'બાકી',
    action: 'કાર્યવાહી',
    overdue: 'મુદત વીતી',
    resolved: 'ઉકેલાયેલ',
    review: 'સમીક્ષા',
    wardPerformance: 'વોર્ડ પ્રદર્શન',
    queue: ['વોર્ડ 12 · કચરાનો ઉભરાવો', 'વોર્ડ 5 · જામ ગટર', 'વોર્ડ 9 · ગંદો રસ્તો'],
  },

  mapIntel: {
    badge: 'નકશો ઇન્ટેલિજન્સ',
    title: 'નાગરિક હૉટસ્પૉટ મોટી સમસ્યા બને તે પહેલાં શોધો',
    subtitle: 'વારંવારની સમસ્યાઓ, ક્લસ્ટર અને મુદત વીતી ગયેલા કાર્યો લાઇવ નકશા પર શોધો — અને ફરિયાદો વધે તે પહેલાં કાર્યવાહી કરો.',
    cta: 'નકશો ઇન્ટેલિજન્સ જુઓ',
    features: [
      'નકશા-આધારિત રિપોર્ટ માર્કર',
      'વોર્ડ-વાર સમસ્યા ક્લસ્ટર',
      'વારંવાર કચરો નાખવાના સ્થળ',
      'મુદત વીતી કાર્ય માર્કર',
      'ઉચ્ચ-ગંભીરતા ફિલ્ટર',
      'શ્રેણી હીટમેપ',
      'હૉટસ્પૉટ ભલામણો',
    ],
    legendHigh: 'ઉચ્ચ ગંભીરતા',
    legendOverdue: 'મુદત વીતી',
    legendResolved: 'ઉકેલાયેલ',
  },

  stakeholder: {
    badge: 'દરેક હિતધારક માટે બનેલ',
    title: 'એક પ્લેટફોર્મ, દરેક ભૂમિકા',
    subtitle: 'એડમિન, અધિકારીઓ, ફિલ્ડ ટીમો, કર્મચારીઓ અને નાગરિકો માટે ખાસ બનાવેલા સાધનો.',
    cards: [
      { title: 'નગરપાલિકા એડમિન', description: 'એક કમાન્ડ સેન્ટરથી આખા શહેરનું સંચાલન કરો.', features: ['રીઅલ-ટાઇમ કમાન્ડ સેન્ટર', 'એસએલએ અને એસ્કેલેશન', 'રિપોર્ટ અને એનાલિટિક્સ', 'પીડીએફ / સીએસવી નિકાસ'] },
      { title: 'વોર્ડ અધિકારી', description: 'તમારા વોર્ડમાં કાર્યની સમીક્ષા, સોંપણી અને ચકાસણી કરો.', features: ['રિપોર્ટ સમીક્ષા', 'સફાઈ કાર્ય સોંપો', 'પૂર્ણતા ચકાસો'] },
      { title: 'ફિલ્ડ અધિકારી', description: 'ચાલતાં-ફરતાં પુરાવા-આધારિત નિરીક્ષણ કૅપ્ચર કરો.', features: ['નિરીક્ષણ કૅપ્ચર', 'એઆઈ વિશ્લેષણ', 'જીપીએસ પુરાવો', 'રિપોર્ટ મોકલો'] },
      { title: 'સફાઈ કર્મચારી', description: 'કાર્યો મેળવો અને પૂર્ણ કરેલ કાર્ય સાબિત કરો.', features: ['કાર્ય મેળવો', 'પછીનો ફોટો અપલોડ કરો', 'કાર્ય પૂર્ણ કરો'] },
      { title: 'નાગરિક', description: 'સમસ્યાઓ નોંધાવો અને તેમને ઉકેલ સુધી ટ્રૅક કરો.', features: ['ફરિયાદ નોંધાવો', 'સ્થિતિ ટ્રૅક કરો', 'પ્રતિસાદ આપો'] },
    ],
  },

  security: {
    badge: 'સુરક્ષા અને શાસન',
    title: 'સુરક્ષિત નાગરિક શાસન માટે નિર્મિત',
    subtitle: 'નગરપાલિકા અને સરકારી ખરીદદારો જેની અપેક્ષા રાખે તેવા એન્ટરપ્રાઇઝ-ગ્રેડ નિયંત્રણો.',
    items: [
      { title: 'ભૂમિકા-આધારિત ઍક્સેસ નિયંત્રણ', desc: 'દરેક ભૂમિકા માત્ર તે જ જુએ છે જે તેને જોવું જોઈએ.' },
      { title: 'ઓડિટ લૉગ', desc: 'દરેક ક્રિયા નોંધાયેલ અને ટ્રૅક કરી શકાય તેવી છે.' },
      { title: 'જીપીએસ અને ટાઇમસ્ટૅમ્પ પુરાવો', desc: 'પુરાવા પર સ્થાન અને સમય અંકિત થાય છે.' },
      { title: 'સુરક્ષિત મીડિયા અપલોડ', desc: 'ફોટા સુરક્ષિત રીતે સંગ્રહાય અને પીરસાય છે.' },
      { title: 'એડમિન સમીક્ષા', desc: 'અધિકારીઓ દરેક કાર્યવાહી મંજૂર કે નકારે છે.' },
      { title: 'એઆઈ ઓવરરાઇડ', desc: 'માણસો કોઈપણ એઆઈ પરિણામ ઓવરરાઇડ કરી શકે છે.' },
      { title: 'પીડીએફ પુરાવો', desc: 'માંગ પર છેડછાડ-રહિત ઓડિટ રિપોર્ટ.' },
      { title: 'ડેટા ગોપનીયતા', desc: 'નાગરિક ડેટા જવાબદારીપૂર્વક સંભાળાય છે.' },
      { title: 'એચટીટીપીએસ સુરક્ષા', desc: 'ટીએલએસ પર એન્ડ-ટુ-એન્ડ એન્ક્રિપ્ટેડ.' },
    ],
  },

  reporting: {
    badge: 'રિપોર્ટિંગ',
    title: 'જવાબદારી માટે આધિકારિક રિપોર્ટ',
    subtitle: 'ઓડિટ-તૈયાર દસ્તાવેજ જે તપાસમાં ટકે છે — આપોઆપ તૈયાર થાય છે.',
    items: [
      'નિરીક્ષણ પીડીએફ',
      'વોર્ડ સારાંશ પીડીએફ',
      'નાગરિક ફરિયાદ પીડીએફ',
      'પહેલાં/પછીની પીડીએફ',
      'માસિક સીએસવી નિકાસ',
      'નિર્ધારિત ઈમેલ રિપોર્ટ',
    ],
    cardTitle: 'નિરીક્ષણ રિપોર્ટ',
    verified: 'ચકાસાયેલ',
    before: 'પહેલાં',
    after: 'પછી',
    rows: [
      { k: 'શ્રેણી', v: 'કચરાનો ઉભરાવો' },
      { k: 'સ્થાન', v: '19.0760, 72.8770' },
      { k: 'નોંધાયેલ', v: '09 જુલાઈ 2026, 09:41' },
      { k: 'બંધ', v: '09 જુલાઈ 2026, 15:20' },
      { k: 'એસએલએ', v: 'પૂર્ણ (5ક 39મિ)' },
    ],
    tamperEvident: 'છેડછાડ-રહિત · ઓડિટ ટ્રેલ જોડાયેલ',
  },

  stats: {
    labels: ['નાગરિક શ્રેણીઓ', 'એઆઈ કાર્યપ્રવાહ', 'વપરાશકર્તા ભૂમિકાઓ', 'પ્લેટફોર્મ ઇન્ટરફેસ'],
  },

  categories: {
    badge: 'નાગરિક શ્રેણીઓ',
    title: 'વ્યાપક કવરેજ',
    subtitle: 'તમામ પ્રકારના નાગરિક માળખા અને સ્વચ્છતા શ્રેણીઓ પર દેખરેખ રાખો',
    unavailable: 'શ્રેણીઓ હાલમાં અનુપલબ્ધ છે.',
    retry: 'ફરી પ્રયાસ કરો',
    empty: 'કોઈ શ્રેણી ઉપલબ્ધ નથી',
    viewAll: 'બધી શ્રેણીઓ જુઓ',
  },

  complaint: {
    badge: 'નાગરિકો માટે',
    title: 'તમારી ફરિયાદ નોંધાવો કે ટ્રૅક કરો',
    subtitle: 'તમારા વિસ્તારમાં નાગરિક સ્વચ્છતા સુધારવામાં મદદ કરો — નવી ફરિયાદ નોંધાવો કે હાલની સ્થિતિ તપાસો.',
    fileTitle: 'નવી ફરિયાદ નોંધાવો',
    fileDesc: 'તમારા વિસ્તારની સ્વચ્છતા સમસ્યાની જાણ કરો. તમારી ઓળખ ગોપનીય રખાય છે અને પ્રગતિ જોવા માટે તમને ટ્રૅકિંગ નંબર મળશે.',
    fileSteps: ['સમસ્યાનો ફોટો અપલોડ કરો', 'શ્રેણી પસંદ કરો', 'તમારું જીપીએસ સ્થાન કૅપ્ચર કરો', 'ટ્રૅકિંગ આઈડી મેળવો'],
    fileCta: 'નવી ફરિયાદ નોંધાવો',
    trackTitle: 'ફરિયાદ ટ્રૅક કરો',
    trackDesc: 'પહેલેથી ફરિયાદ નોંધાવી છે? તેને ટ્રૅકિંગ આઈડીથી કે વન-ટાઇમ પાસવર્ડ સાથે તમારા ફોન નંબરથી ટ્રૅક કરો.',
    trackSteps: ['તમારી ટ્રૅકિંગ આઈડી દાખલ કરો', 'ઓટીપીથી ચકાસો (ફોન દ્વારા)', 'તમારી સ્થિતિ ટાઇમલાઇન જુઓ', 'ઉકેલ પુરાવો જુઓ'],
    trackCta: 'ફરિયાદ ટ્રૅક કરો',
    timelineLabel: 'તમારી ફરિયાદની સ્થિતિ, શરૂથી અંત સુધી',
    statuses: ['નોંધાયેલ', 'સમીક્ષા હેઠળ', 'કાર્યવાહી આયોજિત', 'પ્રગતિમાં', 'ઉકેલાયેલ'],
  },

  faq: {
    badge: 'સામાન્ય પ્રશ્નો',
    title: 'વારંવાર પૂછાતા પ્રશ્નો',
    subtitle: 'નાગરિકો, નગરપાલિકાઓ અને સરકારી ખરીદદારો માટે સીધા જવાબો.',
    stillQuestions: 'હજુ પ્રશ્નો છે?',
    talkToTeam: 'અમારી ટીમ સાથે વાત કરો',
    items: [
      { q: 'સ્વચ્છ ભારત કોણ વાપરી શકે?', a: 'નગરપાલિકાઓ, વોર્ડ અને ફિલ્ડ અધિકારીઓ, સફાઈ કર્મચારીઓ અને સામાન્ય નાગરિકો. દરેક ભૂમિકાને હેતુ-નિર્મિત અનુભવ મળે છે — એડમિન કમાન્ડ સેન્ટરથી લઈને નાગરિક ફરિયાદ ફોર્મ સુધી.' },
      { q: 'શું આ સરકારી એપ્લિકેશન છે?', a: 'સ્વચ્છ ભારત એક ખાનગી કંપની દ્વારા બનાવેલ નાગરિક ટેક્નોલોજી પ્લેટફોર્મ છે. તે નગરપાલિકાઓ અને નાગરિક સત્તાવાળાઓ દ્વારા તૈનાત કરવા માટે બનેલ છે અને કોઈ સરકારી જોડાણનો દાવો કરતું નથી.' },
      { q: 'એઆઈ વિશ્લેષણ કેવી રીતે કામ કરે છે?', a: 'દરેક ફોટોનું એઆઈ (OpenAI GPT-4o Vision) દ્વારા વિશ્લેષણ થાય છે જેથી છબી ગુણવત્તા તપાસાય, નાગરિક સમસ્યા ઓળખાય, સ્વચ્છતા સ્કોર અને ગંભીરતા અપાય, અને કાર્યવાહીની ભલામણ થાય.' },
      { q: 'શું એઆઈ પરિણામોની મેન્યુઅલ સમીક્ષા થઈ શકે?', a: 'હા. એઆઈ નિર્ણયમાં મદદ કરે છે, પણ અધિકૃત અધિકારીઓ કાર્યવાહી પહેલાં કોઈપણ એઆઈ પરિણામની સમીક્ષા, ઓવરરાઇડ, ફરી વિશ્લેષણ કે નકાર કરી શકે છે. નિયંત્રણ માણસો પાસે રહે છે.' },
      { q: 'શું નાગરિકો ફરિયાદો ટ્રૅક કરી શકે?', a: 'હા. નાગરિકોને ટ્રૅકિંગ આઈડી મળે છે અને તેઓ સ્પષ્ટ સ્થિતિ ટાઇમલાઇન અનુસરી શકે છે — નોંધાયેલ, સમીક્ષા હેઠળ, કાર્યવાહી આયોજિત, પ્રગતિમાં, ઉકેલાયેલ — અને ઉકેલ પુરાવો જોઈ શકે છે.' },
      { q: 'શું તે ઓફલાઇન કામ કરે છે?', a: 'ફિલ્ડ કૅપ્ચર અનુભવ મોબાઇલ-પ્રથમ છે અને નબળા નેટવર્કને સહન કરે છે, પુરાવાને કતારમાં રાખી કનેક્ટિવિટી પાછી આવતાં સિંક કરે છે જેથી ફિલ્ડ ટીમો ક્યારેય અટકે નહીં.' },
      { q: 'શું નગરપાલિકા સફાઈ કાર્યો સોંપી શકે?', a: 'હા. વોર્ડ અધિકારીઓ સફાઈ ટીમોને સમયમર્યાદા સાથે કાર્યો સોંપી શકે છે, અને પહેલાં/પછીના પુરાવા તથા એસએલએ ટાઇમર સાથે પૂર્ણતા ટ્રૅક કરી શકે છે.' },
      { q: 'શું તે જીપીએસ પુરાવાને સમર્થન આપે છે?', a: 'દરેક ફોટા પર જીપીએસ કોઓર્ડિનેટ અને ટાઇમસ્ટૅમ્પ અંકિત થાય છે, અને છેતરપિંડી અટકાવવા પછીના ફોટા નોંધાયેલ સ્થાન સામે ચકાસાય છે.' },
      { q: 'શું રિપોર્ટ પીડીએફ તરીકે નિકાસ થઈ શકે?', a: 'હા. નિરીક્ષણ રિપોર્ટ, વોર્ડ સારાંશ, ફરિયાદ રેકોર્ડ અને પહેલાં/પછીના પુરાવા છેડછાડ-રહિત પીડીએફ તરીકે નિકાસ કરી શકાય, સાથે માસિક સીએસવી અને નિર્ધારિત ઈમેલ રિપોર્ટ પણ.' },
      { q: 'શું તેને કોઈ શહેર કે નગરપાલિકા માટે કસ્ટમાઇઝ કરી શકાય?', a: 'હા. શ્રેણીઓ, વોર્ડ, એસએલએ નિયમો, એસ્કેલેશન નીતિઓ અને બ્રાન્ડિંગ દરેક નગરપાલિકા પ્રમાણે ગોઠવી શકાય છે. તમારા શહેરની જરૂરિયાતોની ચર્ચા માટે ડેમો બુક કરો.' },
    ],
  },

  cta: {
    badge: 'શરૂ કરો',
    title: 'નાગરિક સ્વચ્છતા દેખરેખ બદલવા તૈયાર છો?',
    subtitle: 'એઆઈ-સંચાલિત પુરાવા સંગ્રહ, એસએલએ ટ્રૅકિંગ અને કેન્દ્રિત દેખરેખ સાથે સ્વચ્છતા નિરીક્ષણને આધુનિક બનાવવામાં નગરપાલિકાઓ સાથે જોડાઓ.',
    primary: 'નગરપાલિકા ડેમો બુક કરો',
    secondary: 'ફરિયાદ નોંધાવો',
  },

  footer: {
    tagline: 'એઆઈ નાગરિક નિરીક્ષણ પ્લેટફોર્મ',
    description:
      'નગરપાલિકાઓ અને નાગરિક સત્તાવાળાઓ માટે બનાવેલ એન્ટરપ્રાઇઝ-ગ્રેડ ડિજિટલ નાગરિક નિરીક્ષણ પ્લેટફોર્મ. સ્વચ્છ, તંદુરસ્ત સમુદાયો માટે એઆઈ-સંચાલિત સ્વચ્છતા દેખરેખ.',
    india: 'ભારત',
    product: 'ઉત્પાદન',
    company: 'કંપની',
    complaints: 'ફરિયાદો',
    legal: 'કાનૂની',
    links: {
      features: 'વિશેષતાઓ',
      categories: 'શ્રેણીઓ',
      howItWorks: 'આ કેવી રીતે કામ કરે છે',
      solutions: 'ઉકેલો',
      about: 'અમારા વિશે',
      contact: 'સંપર્ક',
      signIn: 'સાઇન ઇન',
      fileComplaint: 'ફરિયાદ નોંધાવો',
      trackComplaint: 'તમારી ફરિયાદ ટ્રૅક કરો',
      privacy: 'ગોપનીયતા નીતિ',
      terms: 'સેવાની શરતો',
    },
    ctaTitle: 'શરૂ કરવા તૈયાર છો?',
    ctaSubtitle: 'આજે જ તમારી નગરપાલિકાની નાગરિક નિરીક્ષણ પ્રક્રિયા બદલો.',
    requestDemo: 'ડેમોની વિનંતી કરો',
    signIn: 'સાઇન ઇન',
    rights: 'સર્વ હક્ક સુરક્ષિત.',
    designedFor: 'નગરપાલિકાઓ અને નાગરિક સત્તાવાળાઓ માટે ડિઝાઇન કરેલ',
  },
};
